import { Centred, Contents } from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme),
    [theme.breakpoints.down('xs')]: {
      padding: 20
    }
  },
  contents: {
    ...Contents(theme),
  },
  footer: {
    background: '#333',
    '& p': {
      fontWeight: 100,
      color: 'rgba(255,255,255,1)',
    },
    '& h3': {
      fontWeight: 400,
      color: 'rgba(255,255,255,1)',
    },
  },
  footerRow: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    alignItems: 'center',
    '& > div': {
      [theme.breakpoints.down('xs')]: {
        marginBottom: 5,
        marginTop: 5
      },
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit * 2,
    }
  },
  footerRowLinks: {
    textTransform: 'uppercase',
    borderBottom: '1px solid rgba(255,255,255,.1)',
    '& span': {
      color: 'rgba(255,255,255,1)',
      display: 'inline',
      marginRight: theme.spacing.unit * 2,
    },
    '& img': {
      height: 30,
      verticalAlign: 'middle',
      marginRight: 20,
    },
    '& a': {
      color: 'rgba(255,255,255,1)',
      textUnderlinePosition: 'under',
    },
    [theme.breakpoints.down('xs')]: {
      '& a': {
        fontSize: 16
      }
    },
  },
  footerRowItem: {
    marginBottom: 10
  },
  footerRowCreds: {
    textTransform: 'uppercase',
    borderBottom: '1px solid rgba(255,255,255,.1)',
    '& span': {
      color: 'rgba(255,255,255,1)',
      display: 'inline',
      marginRight: theme.spacing.unit * 2,
    },
    '& img': {
      height: 120,
      verticalAlign: 'middle',
      margin: '0px 30px 30px 0px',
    },
    '& a': {
      color: 'rgba(255,255,255,1)',
      textUnderlinePosition: 'under',
    },
  },
  footerEnd: {
    marginTop: theme.spacing.unit * 10,
    '& span': {
      color: 'rgba(255,255,255,.5)',
    },
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/footer/styles.js